// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"InfoSection_sectionWrapper__3g2wy","sectionContent":"InfoSection_sectionContent__2ZOfe"};